var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkipNext(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Decorative_icon",
    "data-name": "Decorative icon",
    transform: "translate(38.283 38.283) rotate(180)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Placement_Area",
    "data-name": "Placement Area",
    width: 38,
    height: 38,
    transform: "translate(0.283 0.283)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-0.217 -0.217)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Canvas",
    width: 38,
    height: 39,
    transform: "translate(0.5 -0.5)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2060",
    "data-name": "Rectangle 2060",
    width: 9,
    height: 30,
    rx: 0.5,
    transform: "translate(27.5 4.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2472",
    "data-name": "Path 2472",
    d: "M20.336,30.744V3.11A1.07,1.07,0,0,0,18.6,2.275L1.327,16.092a1.07,1.07,0,0,0,0,1.671L18.6,31.58a1.07,1.07,0,0,0,1.738-.835Z",
    transform: "translate(1.302 2.573)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipNext);
export default __webpack_public_path__ + "static/media/skip_next.c1ab9528a64edd387f5077a9a015eb55.svg";
export { ForwardRef as ReactComponent };